import { Injectable } from "@angular/core";

export type ThemeMode = "light" | "dark";

@Injectable({ providedIn: "root" })
export class ThemeService {
    private readonly storageKey = "calsium-theme";
    private mode: ThemeMode;

    constructor() {
        this.mode = localStorage.getItem(this.storageKey) === "dark" ? "dark" : "light";
        this.applyTheme();
    }

    get isDarkMode(): boolean {
        return this.mode === "dark";
    }

    toggle(): void {
        this.setDarkMode(!this.isDarkMode);
    }

    setDarkMode(isDark: boolean): void {
        this.mode = isDark ? "dark" : "light";
        this.applyTheme();
    }

    private applyTheme(): void {
        const root = document.documentElement;
        root.classList.add("scania");
        root.classList.toggle("tds-mode-dark", this.isDarkMode);
        root.classList.toggle("tds-mode-light", !this.isDarkMode);
        root.setAttribute("data-theme", this.mode);
        localStorage.setItem(this.storageKey, this.mode);
    }
}
